import { useQuery } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { useOrderOnBehalf } from "./useOrderOnBehalf";

/** Session-scoped contract requests cannot update another session's display. */
export function useStorefrontPrices() {
  const { user, pricingScope } = useAuth();
  const { customer } = useOrderOnBehalf();
  const enabled = !!user && (user.accountStatus === "active" || !!customer);
  const { data } = useQuery<Record<number, string>>({
    queryKey: ["storefront-contract-prices", pricingScope, customer?.id],
    enabled,
    queryFn: async ({ signal }) => {
      const url = customer
        ? `/api/customer-prices/for-customer/${customer.id}/all-prices`
        : "/api/customer-prices/my-prices";
      const res = await fetch(url, { signal, credentials: "include", cache: "no-store" });
      if (!res.ok) throw new Error("Unable to load account pricing");
      return res.json();
    },
  });
  return enabled ? data ?? {} : {};
}
